// This is a legacy file that is only used for hit tracking on portfolio pages.
// Trying to change it breaks things.
// For any other page, see js/utils/loadRecordHit.ts

var $auvid;
var Aedu = {};
var $start_time = new Date().getTime();

// This is a non-ajax version of record_hit.js
(function() {
  var portfolio = {

    getCookie: function(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    setCookie: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },

    // Logged-in users will have hits recorded directly in Rails, rather
    // than via JS, because we know pages are never served to them from
    // the cache
    recordHitIfNotRecorded: function() {
      // Recording of `request_id` is broken for logged-out hits; see
      // https://github.com/academia-edu/academia-app/issues/26202.
      //
      // When this file is moved over to Webpack, we can use the `getRequestId`
      // function instead of duplicating the following couple of lines.
      const match = document.cookie.match('(^|; )request_id=([^;]*)');
      if (match) {
        var requestId = match[2] && decodeURIComponent(match[2]);
      }

      if (!Aedu.hit_data) {
        this.recordHit({
          url: '' + window.location,
          referrer: document.referrer,
          request_id: requestId,
        });
      }
    },

    recordHit: function(data) {
      fetch('/record_hit', {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data){
        Aedu.hit_data = data;
        if (data.auvid != $auvid) {
          console.log("Unexpected auvid mismatch: client="+$auvid+" & server="+data.auvid);
        }
      });
    },

    setAuvid: function() {
      var auvidCookieKey = 'auvid',
        auvidCookie = this.getCookie(auvidCookieKey);

      if (auvidCookie == null) {
        var randNum     = Math.random(),
          $start_time = $start_time || new Date().getTime(),
          auvidNewVal = btoa('' + $start_time + ':' + randNum);

        this.setCookie(auvidCookieKey, auvidNewVal, 30);

        $auvid = auvidNewVal;
      } else {
        $auvid = auvidCookie;
      }
    },

    pageLoaded: function() {
      this.setAuvid();
      this.recordHitIfNotRecorded();
      // 365 was the jqeury default
      this.setCookie('from_cache', '', 365);
    }
  };

  document.addEventListener('DOMContentLoaded', function(){
    portfolio.pageLoaded();
  });
})();
